module.exports = __webpack_public_path__ + "static/media/tryolx.7007e74b.PNG";